import React from 'react';
import ModalShell from './ModalShell';
import FormField from './FormField';
import ModalFormFooter from './ModalFormFooter';
import useFormState from '../../hooks/useFormState';

const ResourceFormModal = ({
  isOpen,
  onClose,
  mode = 'create',
  title,
  fields = [],
  initialValues = {},
  onSubmit,
  gridClassName = 'flex flex-col gap-4',
  submitLabel,
  maxWidthClass,
}) => {
  const {
    formData,
    handleChange,
    isLoading,
    setIsLoading,
    isCreateDisabled,
    isSubmitDisabled,
  } = useFormState({ initialValues, isOpen, mode });

  const handleCancel = () => {
    onClose();
  };

  const handleSave = async () => {
    setIsLoading(true);
    try {
      await onSubmit(formData);
    } finally {
      setIsLoading(false);
    }
  };

  const disabled =
    isLoading ||
    (mode === 'create' ? isCreateDisabled(fields) : isSubmitDisabled);

  return (
    <ModalShell
      isOpen={isOpen}
      onClose={handleCancel}
      title={title}
      maxWidthClass={maxWidthClass}
      footer={
        <ModalFormFooter
          onCancel={handleCancel}
          onSubmit={handleSave}
          isLoading={isLoading}
          isDisabled={disabled}
          submitLabel={submitLabel || (mode === 'edit' ? 'Save Changes' : 'Create')}
          loadingLabel={mode === 'edit' ? 'Saving...' : 'Creating...'}
        />
      }
    >
      <form onSubmit={(e) => e.preventDefault()}>
        <div className={gridClassName}>
          {fields.map((field) => (
            <FormField
              key={field.name}
              field={field}
              value={formData[field.name]}
              onChange={handleChange}
            />
          ))}
        </div>
      </form>
    </ModalShell>
  );
};

export default ResourceFormModal;
